/**
 * One radius family, capped at 20px. `2xl`/`3xl` are intentionally NOT defined — do not use them.
 * sm 6  → badge inner, chips, skeleton rows, segment buttons
 * md 10 → inputs, secondary/ghost buttons, table container, tooltips
 * lg 14 → cards, stat tiles, sunken panels, popovers
 * xl 20 → hero band, modals, login card
 * full  → primary CTA, nav pills, badges, avatars
 */
export const radii = {
  none: "0",
  sm: "6px",
  md: "10px",
  lg: "14px",
  xl: "20px",
  full: "9999px",
};
